
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { defaultKeyPicture } from "@/utils/constants";
import heic2any from "heic2any";
import exifr from "exifr";
import { Getter } from "vuex-class";

@Component({
        components: {
        },
    })

export default class KeyCarousel extends Vue {

    get currentPicture(): any {
        return this.pictures[this.carouselIndex];
    }

    get carouselImages(): any[] {
      return this.pictures.map((picture: any, index: number) => ({
        id : picture.id,
        awsSrc : this.awsSrc[index],
        src: picture.picturePath,
      }));
    }

    @Prop({default: false})
    public show: boolean;
    @Prop({default: () => []})
    public pictures: any[];
    @Prop({default: null})
    public typeUser: any;
    @Prop({default: false})
    public hasRightPicture: boolean;
    @Prop({default: null})
    private keyId: number;

    @Getter private currentUser: any;
    @Getter private isMobile: boolean;

    private validDelete: boolean = false;
    private carousel: boolean = true;
    private showAddPicture: boolean = false;
    private carouselIndex: number = 0;
    private uploadedImageSrc: any = null;
    private defaultKeyPicture: string = defaultKeyPicture;
    private avatar: any = null;
    private imgName: string = null;
    private loadingKey: boolean = false;
    private heicFile: any = null;
    private showUpdate: boolean = false;
    private infoPicture: any;
    private showMetaDAta: boolean = false;
    private noData: boolean = false;
    private imgDetail: string = null;
    private skip: boolean = false;
    private valideGeolocation: boolean = false;
    private hasMetaData: boolean = false;
    private validAdd: boolean = false;
    private awsSrc: string[] = [];


  @Watch("currentPicture")
    public handler(): void {
        this.showMetaDAta = false;
        this.noData = false;
    }

  private mySrcUpdate() {
    this.$forceUpdate();
  }

  private mounted(): void {
    this.$on("myupdate", this.mySrcUpdate);

  }

  private beforeDestroy(): void {
    this.$off("myupdate", this.mySrcUpdate);
  }


  private carouselOnOff() {
        this.carousel = !this.carousel;
    }

    private switchDelete() {
        this.validDelete = !this.validDelete;
        this.carouselOnOff();
    }

    private switchAdd() {
        this.showAddPicture = !this.showAddPicture;
        this.carouselOnOff();
    }

    private switchUpdate() {
        this.imgName = this.currentPicture.pictureName;
        this.imgDetail = this.currentPicture.detail;
        this.infoPicture = this.currentPicture;
        this.carouselOnOff();
        this.showUpdate = !this.showUpdate;
    }

    private switchMetaData() {
        this.showMetaDAta = !this.showMetaDAta;
        if (!this.currentPicture.metaData) {
            this.noData = !this.noData;
        }
    }

    private closeLocation() {
        this.valideGeolocation = false;
        this.carousel = true;
    }
    private close(): void {
        this.valideGeolocation = false;
        this.imgName = "";
        this.imgDetail = "";
        this.hasMetaData = false;
        this.imgName = "";
        this.imgDetail = "";
        this.showAddPicture = false;
        this.showUpdate = false;
        this.carousel = true;
        this.validDelete = false;
        this.$emit("close");
    }

    private async deleteImg(): Promise<void> {
        await this.$store.dispatch("keys/deletePicture", {
            keyId: this.keyId,
            keyPictureId: this.currentPicture.id,
        });
        this.$store.commit("alerts/displaySuccess", {
          icon: "icon-picto_cle-partagees",
          msg: this.$t("keyPicture.delete"),
        });
        this.$emit("refresh");
        this.close();
    }

    private updateInfoImg(): Promise<any> {
        const keyPictureData: any = {
            detail: this.imgDetail,
            oldName: this.currentPicture.pictureName,
            pictureName: this.imgName,
            profile: this.infoPicture.profile,
        };
        return this.$store.dispatch("keys/updatePicture", {
            keyId: this.keyId,
            keyPictureId: this.infoPicture.id,
            keyPictureData,
        }).then(() => {
            this.$store.commit("alerts/displaySuccess",
            { icon: "icon-picto_cle-partagees", msg: this.$t("keyPicture.updateInfo")});
            this.$emit("refresh");
            this.close();
        });
    }

    private async updateProfilePicture(newProfilePictureId: number): Promise<void> {
        if (this.currentPicture.profile) {
            await this.$store.dispatch("keys/updateProfilePicture", {
                keyId: this.keyId,
                keyPictureId: newProfilePictureId,
            });
            this.$emit("refresh");
            this.close();
        } else {
            this.$store.commit("alerts/displayError",
            {msg: this.$t("keyPicture.profileError")});
        }
    }

    private skipMetadata(): void {
        this.hasMetaData = true;
        this.saveThePicture();
    }

    private async saveThePicture(): Promise<void> {
        const newPicture: any = [];
        const metaData = await exifr.parse(this.avatar, [
            "GPSLatitudeRef",
            "GPSLongitudeRef",
            "CreateDate",
            "ModifyDate",
            "GPSLatitude",
            "GPSLongitude",
            "DeviceSettingDescription",
            "FileSource",
            "GPSAltitude",
            "GPSAltitudeRef",
            "GPSDateStamp",
            "GPSProcessingMethod",
            "GPSTimeStamp",
            "GPSVersionID",
            // 'Make',
            // 'Model',
        ]);
        const savePicture = () => {
            navigator.geolocation.getCurrentPosition((position) => {
                newPicture.uploadLatitude = position.coords.latitude;
                newPicture.uploadLongitude = position.coords.longitude;
            });
            if ( metaData  || this.hasMetaData) {
                if (this.heicFile || this.avatar) {
                    newPicture.avatar = this.avatar;
                    newPicture.heicFile = this.heicFile;
                    newPicture.name = (this.imgName || "key-picture" + Date.now()) ;
                    this.$emit("save-picture", newPicture);
                    this.close();
                } else {
                    this.$store.commit("alerts/displayError",
                    {msg: "error"});
                }
            } else {
                this.showAddPicture = false;
                this.valideGeolocation = false;
                this.validAdd = true;
            }
        };
        if (navigator.geolocation && navigator.permissions?.query) {
            navigator.permissions.query({ name: "geolocation" })
            .then(
                (permissionStatus) => {
                    if (permissionStatus.state === "granted" || this.skip === true) {
                       savePicture();
                    } else {
                        this.showAddPicture = false;
                        this.valideGeolocation = true;
                    }
                },
            );
        } else if (navigator.geolocation) {
            savePicture();
        }
    }

    private async fileChange(): Promise<void> {
        this.loadingKey = true;
        this.heicFile = null;
        if (this.avatar) {
            if (this.avatar.type === "image/heif" || this.avatar.type === "image/heic") {
                const blob = this.avatar as Blob;
                this.heicFile = await heic2any({blob});
                const fr = new FileReader();
                fr.readAsDataURL(this.heicFile as Blob);
                fr.addEventListener("load", () => {
                    this.uploadedImageSrc = fr.result;
                });
            } else {
                const fr = new FileReader();
                fr.readAsDataURL(this.avatar);
                fr.addEventListener("load", () => {
                    this.uploadedImageSrc = fr.result;
                });
            }
        } else {
            this.uploadedImageSrc = null;
        }
        this.loadingKey = false;
    }
}
